import { alpha, Box, IconButton, SvgIcon } from '@mui/material';
import { FC } from 'react';
import DeleteIcon from '../../../../../icons/svg/delete.svg?react';

type Props = {
  onDelete: () => void;
  width?: string;
  height?: string;
};

export const ActionOverlay: FC<Props> = ({ onDelete, width = undefined, height = undefined }) => {
  return (
    <Box
      className="file-upload-overlay"
      sx={(theme) => ({
        display: 'none',
        position: 'absolute',
        top: '0',
        backgroundColor: alpha(theme.palette.grey[900], 0.6),
        height: (height ? `${parseInt(height) - 10}px` : undefined) || '70px',
        width: width || '200px'
      })}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            borderRadius: '8px',
            background: 'white'
          }}
        >
          <IconButton disableRipple onClick={onDelete}>
            <SvgIcon component={DeleteIcon} color={'primary'} />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};
